import { consumeAuthRedirectTarget } from '~/utils/authRedirect'

export default defineNuxtPlugin(() => {
  const route = useRoute()
  const { loggedIn } = useOidcAuth()

  watch(
    loggedIn,
    async (isLoggedIn) => {
      if (!isLoggedIn) return

      const target = consumeAuthRedirectTarget()
      if (!target || target === route.fullPath) return

      await navigateTo(target)
    },
    { immediate: true }
  )
})

